// Animations //
const loading1 = require("./animations/loading/loader1.json");

const options = {
  loading1,
};

// eslint-disable-next-line import/prefer-default-export
export { options };
